module.exports = __webpack_public_path__ + "img/activities-6.3f5b685e.jpg";